/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import QText from './QText';
import { useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import InfoIcon from './Icons/InfoIcon';

const BatchTimeChangeNote = () => {
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <View style={styles.contentRow}>
        <InfoIcon width={16} height={16} color="rgba(30, 125, 80, 0.8)" />
        <QText style={styles.text}>{t('batch_time_change_note')}</QText>
      </View>
    </View>
  );
};

const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      backgroundColor: 'rgba(46, 175, 120, 0.15)',
      borderColor: 'rgba(46, 175, 120, 0.3)',
      borderWidth: 1,
      borderRadius: 8,
      padding: 12,
      marginBottom: 16,
      width: '100%',
      alignSelf: 'center',
    },
    contentRow: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 8,
    },
    text: {
      color: 'rgba(30, 125, 80, 0.9)',
      fontSize: 12,
      lineHeight: 16,
      flex: 1,
      textAlign: 'left',
    },
  });

export default BatchTimeChangeNote;
